import { FC } from 'react';

import styles from '../AnalyticsView.module.scss';
import { AnalyticsTagGroup } from '../lib/groupTagsByGroupCode';

import { AnalyticsTagChip } from './AnalyticsTagChip';

type AnalyticsTagCardProps = {
  group: AnalyticsTagGroup;
};

export const AnalyticsTagCard: FC<AnalyticsTagCardProps> = (props) => {
  const { group } = props;

  return (
    <div className={styles.tagCard} data-component="analytics-tag-card">
      <p className={styles.tagCardLabel}>{group.name}</p>
      <div className={styles.tagChips}>
        {group.tags.map((tag) => (
          <AnalyticsTagChip key={`${group.code}-${tag.tag_code}`} tag={tag} />
        ))}
      </div>
    </div>
  );
};
